import { ReactNode } from 'react';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { AmbientBackground } from '../AmbientBackground';

interface PageLayoutProps {
  children: ReactNode;
  showAmbientBackground?: boolean;
}

export const PageLayout = ({ children, showAmbientBackground = true }: PageLayoutProps) => {
  return (
    <>
      {showAmbientBackground && <AmbientBackground />}
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
};
